import { api } from '@/services/api/main/axios';

export const getSharedReportsApiRequest = async (): Promise<unknown[]> => {
  const response = await api.get<{ payload: unknown[] }>('v1/shared-reports');
  const payload = response.data.payload;
  return Array.isArray(payload) ? payload : [];
};

export const postSharedReportApiRequest = async (
  params: Record<string, unknown>,
): Promise<unknown> => {
  const response = await api.post<{ payload: unknown }>('v1/shared-reports', params);
  return response.data.payload;
};

export const putSharedReportApiRequest = async (
  id: string,
  params: Record<string, unknown>,
): Promise<unknown> => {
  const response = await api.put<{ payload: unknown }>(`v1/shared-reports/${id}`, params);
  return response.data.payload;
};

export const deleteSharedReportApiRequest = async (id: string): Promise<void> => {
  await api.delete(`v1/shared-reports/${id}`);
};
